var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"study"},[_c('div',{staticClass:"left"},[_c('div',{on:{"click":_vm.openChat}},[_c('img',{attrs:{"src":require("@/assets/img/productDetail/icon_custom.png"),"alt":""}}),_c('span',[_vm._v("咨询")])])]),_c('button',{staticClass:"to-study",on:{"click":_vm.goQiHangMini}},[_vm._v("前往 [启航考研] 购买")])])
}
var staticRenderFns = []

export { render, staticRenderFns }